var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "v-list",
        { attrs: { "two-line": "" } },
        [
          _vm._l(_vm.messages, function(message, index) {
            return [
              _c(
                "v-list-item",
                {
                  key: message.id,
                  staticClass: "message-list-item",
                  attrs: { avatar: "" }
                },
                [
                  _c(
                    "v-list-item-avatar",
                    {
                      staticStyle: { height: "40px !important" },
                      attrs: {
                        color: message.company_id === null ? "primary" : "grey"
                      }
                    },
                    [
                      _c(
                        "h3",
                        {
                          staticClass: "white--text",
                          staticStyle: { top: "1px", position: "relative" }
                        },
                        [_vm._v(_vm._s(message.created_by_name.charAt(0)))]
                      )
                    ]
                  ),
                  _c(
                    "v-list-item-content",
                    { staticStyle: { height: "auto", "text-justify": "auto" } },
                    [
                      _c(
                        "v-list-item-title",
                        [
                          _c(
                            "v-row",
                            { attrs: { "no-gutters": "" } },
                            [
                              _c(
                                "span",
                                {
                                  staticClass:
                                    "align-content-end headline mt-2 mr-5"
                                },
                                [
                                  _vm._v(
                                    " " + _vm._s(message.created_by_name) + " "
                                  ),
                                  _c("span", { staticClass: "date-style" }, [
                                    _vm._v(_vm._s(message.created_at))
                                  ])
                                ]
                              ),
                              typeof message.orderItem !== "undefined" &&
                              message.orderItem.id !==
                                _vm.travelServiceOrderItemId
                                ? _c("travel-service-order-item-chip", {
                                    attrs: {
                                      "travel-service-order-item":
                                        message.orderItem,
                                      "click-url":
                                        _vm.$store.getters["companyContext"] ===
                                        null
                                          ? "/admin/travel-service/item/readonly/"
                                          : "/travel-service/item-details/",
                                      "new-tab": true
                                    }
                                  })
                                : _vm._e()
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "v-list-item-subtitle",
                        { staticClass: "message-list-subtitle" },
                        [_vm._v(" " + _vm._s(message.message) + " ")]
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              index !== _vm.messages.length - 1
                ? _c("v-divider", { key: -index, attrs: { inset: true } })
                : _vm._e()
            ]
          })
        ],
        2
      ),
      _c(
        "v-row",
        { staticClass: "pl-1", attrs: { "no-gutters": "" } },
        [
          _c(
            "v-avatar",
            { staticClass: "ma-2", attrs: { color: "accent" } },
            [_c("v-icon", { attrs: { color: "white" } }, [_vm._v("fa-plus")])],
            1
          ),
          _c("v-textarea", {
            attrs: {
              "auto-grow": "",
              "full-width": "",
              "hide-details": "",
              outlined: "",
              placeholder: _vm.$t("global.messageContent")
            },
            model: {
              value: _vm.content,
              callback: function($$v) {
                _vm.content = $$v
              },
              expression: "content"
            }
          })
        ],
        1
      ),
      _c(
        "v-row",
        { staticClass: "pl-1", attrs: { "no-gutters": "" } },
        [
          _c(
            "v-tooltip",
            {
              attrs: { top: "" },
              scopedSlots: _vm._u([
                {
                  key: "activator",
                  fn: function(ref) {
                    var on = ref.on
                    return [
                      _c(
                        "v-avatar",
                        _vm._g(
                          {
                            staticClass: "mx-2",
                            staticStyle: { position: "relative", top: "-4px" },
                            attrs: { color: !_vm.showAll ? "grey" : "primary" },
                            on: {
                              click: function($event) {
                                _vm.showAll = !_vm.showAll
                              }
                            }
                          },
                          on
                        ),
                        [
                          _c("v-icon", { attrs: { color: "white" } }, [
                            _vm._v("fa-project-diagram")
                          ])
                        ],
                        1
                      )
                    ]
                  }
                }
              ])
            },
            [
              !_vm.showAll
                ? _c("span", [
                    _vm._v(
                      _vm._s(_vm.$t("global.showMessagesFromLinkedOrders"))
                    )
                  ])
                : _vm._e(),
              _vm.showAll
                ? _c("span", [
                    _vm._v(
                      _vm._s(_vm.$t("global.showMessagesOnlyFromThisOrder"))
                    )
                  ])
                : _vm._e()
            ]
          ),
          _c(
            "v-row",
            { staticClass: "px-3 py-1" },
            [
              _c(
                "v-btn",
                {
                  staticStyle: { width: "100%" },
                  attrs: {
                    disabled: _vm.$store.getters["Ajax/loading"],
                    color: "accent"
                  },
                  on: {
                    click: function($event) {
                      return _vm.send()
                    }
                  }
                },
                [_vm._v(" " + _vm._s(_vm.$t("global.sendMessage")) + " ")]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }